import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';

interface AuthCTAProps {
  label: ReactNode;
  leftIcon?: ReactNode;
  rightChevron?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  ariaDisabled?: boolean;
  className?: string;
  tone?: 'primary' | 'secondary';
}

export function AuthCTA({
  label,
  leftIcon,
  rightChevron = true,
  onClick,
  type = 'button',
  disabled,
  ariaDisabled,
  className,
  tone = 'primary',
}: AuthCTAProps) {
  const isPrimary = tone === 'primary';

  return (
    <div
      className="group relative inline-block w-full rounded-[var(--radius-lg)] bg-gradient-to-b from-black/10 to-white/10 
                        dark:from-white/10 dark:to-black/10 p-px rounded-[var(--radius-lg)] backdrop-blur-lg 
                        overflow-hidden transition-shadow duration-[time:var(--t-spring)]"
    >
      <Button
        type={type}
        variant="ghost"
        onClick={onClick}
        disabled={disabled}
        aria-disabled={ariaDisabled}
        className={`rounded-[1.15rem] px-8 py-6 text-lg font-semibold backdrop-blur-md 
                            transition-all duration-[time:var(--t-spring)] w-full disabled:opacity-75 disabled:text-black/80 dark:disabled:text-white/80
                            group-hover:-translate-y-0.5 border border-black/10 dark:border-white/10
                            dark:hover:shadow-neutral-800/50 ${
                              isPrimary
                                ? 'bg-black text-white hover:bg-black/90 dark:bg-white dark:text-black dark:hover:bg-white/90'
                                : 'bg-white/95 hover:bg-white/100 dark:bg-black/95 dark:hover:bg-black/100 text-black dark:text-white'
                            } ${className ?? ''}`}
      >
        {leftIcon}
        <span className="opacity-90 group-hover:opacity-100 transition-opacity">{label}</span>
        {rightChevron ? (
          <span
            className="ml-3 opacity-70 group-hover:opacity-100 group-hover:translate-x-1.5 
                                transition-all duration-[time:var(--t-spring)]"
          >
            →
          </span>
        ) : null}
      </Button>
    </div>
  );
}
